export const isCurrentPage = (testPage: string, currentPage: string) => {
  if (currentPage && testPage) {
    return currentPage === testPage;
  } else return false;
};

export const UNDERLINE_CLASS_LARGE =
  " duration-300 underline hover:underline-offset-4 underline-offset-8 decoration-2";

export const UNDERLINE_CLASS_LARGE_DISABLED =
  " duration-300 underline hover:underline-offset-4 underline-offset-4 decoration-2";
export const UNDERLINE_CLASS =
  " duration-300 underline underline-offset-4 hover:underline-offset-2 decoration-1";

export const UNDERLINE_CLASS_DISABLED =
  " duration-300 underline underline-offset-2 hover:underline-offset-2 decoration-1";
